import { createContext, useReducer, useEffect } from "react";
import sponsorReducer from "./SponsorReducer";

import { getAllSponsors, createSponsor } from "../../services/sponsors";

import { toast } from "react-toastify";
import { mapSponsorData } from "../../utils/dataMapping";

// const access_token = localStorage.getItem("accessToken");

const SponsorContext = createContext();

export const SponsorProvider = ({ children }) => {
  const requestFailed = () =>
    toast.error("Something went wrong", {
      // theme: "colored",
      toastId: "requestFailed",
    });

  const initialState = {
    sponsorsData: [],
    load: false,
    totalCount: 0,
  };

  const [state, dispatch] = useReducer(sponsorReducer, initialState);

  // const fetchSponsors = async (pageNumber, pageSize, sortingType, sortingField, debouncedSearchString, filters) => {
  //   setLoading();
  //   try {
  //     const res = await getAllSponsors(pageNumber, pageSize, sortingType, sortingField, debouncedSearchString, filters);
  //     if (res.status === "Success") {
  //       const mappedData = mapSponsorData(res.result);
  //       dispatch({
  //         type: "GET_SPONSORS",
  //         payload: mappedData,
  //       });
  //       dispatch({
  //         type: "SET_TOTAL_COUNT",
  //         payload: res.totalCount,
  //       });
  //     } else {
  //       console.error("Failed to fetch sponsors:", res.message);
  //       requestFailed();
  //     }
  //   } catch (err) {
  //     console.error("Error: ", err.message);
  //     requestFailed();
  //   } finally {
  //     disableLoading();
  //   }
  // };
  const fetchSponsors = async (pageNumber, pageSize, sortingType, sortingField, debouncedSearchString, filters) => {
    setLoading();
    try {
      const res = await getAllSponsors(pageNumber, pageSize, sortingType, sortingField, debouncedSearchString, filters);
      if (res.status === "Success") {
        let mappedData = mapSponsorData(res.result);
        if (sortingField && (sortingType === 'asc' || sortingType === 'desc')) {
          mappedData = mappedData.sort((a, b) => {
            const valueA = a[sortingField] ?? "";
            const valueB = b[sortingField] ?? "";
            if (typeof valueA === 'string' && typeof valueB === 'string') {
              return sortingType === 'asc'
                ? valueA.localeCompare(valueB)
                : valueB.localeCompare(valueA);
            } else {
              return 0;
            }
          });
        }
        
        dispatch({
          type: "GET_SPONSORS",
          payload: mappedData,
        });
        dispatch({
          type: "SET_TOTAL_COUNT",
          payload: res.totalCount,
        });
      } else {
        console.error("Failed to fetch sponsors:", res.message);
        requestFailed();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || "An unknown error occurred";
      console.error("Error: ", errorMessage);
      requestFailed();
    } finally {
      disableLoading();
    }
  };
  
  

  const sponsorCreation = async (name, fileUrl) => {
    try {
      const res = await createSponsor({
        name,
        fileUrl,
      });

      return res;
    } catch (err) {
      console.log("submit error: ", err);
      requestFailed();
    }
  };

  // Set Loading
  const setLoading = () => dispatch({ type: "SET_LOADING" });

  // Disable Loading
  const disableLoading = () => dispatch({ type: "DISABLE_LOADING" });

  // useEffect(() => {
  //   fetchSponsors();
  // }, []);
  
  return (
    <SponsorContext.Provider
      value={{
        sponsorsData: state.sponsorsData,
        load: state.load,
        setLoading,
        sponsorCreation,
        disableLoading,
        fetchSponsors,
        totalCount: state.totalCount,
      }}
    >
      {children}
    </SponsorContext.Provider>
  );
};

export default SponsorContext;
